// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_-dY","cls2":"FocusedNavView-cls2_Hhc FocusedNavView-cls1_-dY","inDevStyle":"FocusedNavView-inDevStyle_633","useGrid":"FocusedNavView-useGrid_Hhn"};